var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":"","color":"primary lighten-1"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link,attrs:{"color":"white","flat":"","round":""}},[_vm._v("\n      "+_vm._s(link)+"\n    ")])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7362ed92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 